<h1 mat-dialog-title class="confirmationfont">Confirmation</h1>
<mat-dialog-content>{{ message }}</mat-dialog-content>
<mat-dialog-actions>
  <button class="yesButton" mat-button (click)="onConfirm(true)">Yes</button>
  <button class="noButton" mat-button (click)="onConfirm(false)">No</button>
</mat-dialog-actions>